import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import moment from 'moment';
import _ from 'lodash';
import { Form, FormGroup, Input, Label, Col, Button, Row, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { ReactComponent as GoodsIcon } from 'bootstrap-icons/icons/box.svg';
import { ReactComponent as TrackIcon } from 'bootstrap-icons/icons/geo-alt-fill.svg';
import { ReactComponent as DocumentsIcon } from 'bootstrap-icons/icons/files.svg';
import { ReactComponent as PodIcon } from 'bootstrap-icons/icons/journal-check.svg';
import { ReactComponent as ProblemIcon } from 'bootstrap-icons/icons/exclamation-diamond-fill.svg';
import { ReactComponent as NotesIcon } from 'bootstrap-icons/icons/journals.svg';
import { ReactComponent as PrinterIcon } from 'bootstrap-icons/icons/printer-fill.svg';
import { handleResponse } from '../utils/handlers';

import styles from './Consignment.module.css';

function ConsignmentDetails(props) {

    let history = useHistory();
    let { authenticatedUser } = useContext(AuthContext);

    if (props.consignment === null)
        return null;

    var navigateToGoodsDetails = (e) => {
        history.push('/goods-details', props.consignment.goods);
    };

    var navigateToTrackingDetails = (e) => {
        history.push('/tracking-details', props.consignment);
    };

    var navigateToConsignmentDocuments = (e) => {
        history.push(`/consignment/${props.consignment.consignmentID}/documents`);
    };

    var navigateToConsignmentPods = (e) => {
        history.push(`/consignment/${props.consignment.consignmentID}/pods`);
    };

    var navigateToChargingNotes = (e) => {
        history.push(`/consignment/${props.consignment.consignmentID}/charging-notes`, props.consignment.chargingNotes);
    };

    var handleProblem = (e) => {

        if (props.consignment.isProblem === true) {

            var headers = new Headers();
            headers.append('Content-Type', 'application/json');

            fetch(`api/consignments/${props.consignment.consignmentID}/problem`, {
                credentials: 'include',
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    isProblem: false
                })})
                .then(handleResponse)
                .then(data => {
                    window.location.reload();
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            history.push(`/consignment/${props.consignment.consignmentID}/problem`, props.consignment.chargingNotes);
        }

    };

    function printConsignmentReport(useOverPrintMode) {

        var printerName = useOverPrintMode ?
            authenticatedUser?.fmeUserInfo?.defaultDepotPrinter?.printerName :
            authenticatedUser?.fmeUserInfo?.defaultDepotPlainPaperPrinter?.printerName;

        if (printerName) {

            var headers = new Headers();
            headers.append('Content-Type', 'application/json');

            fetch(`api/consignments/${props.consignment.consignmentID}/print/ConsignmentReport`, {
                credentials: 'include',
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    printerName: printerName,
                    useOverPrintMode: useOverPrintMode || false
                })})
                .then(response => {
                    if (props.onPrinted)
                        props.onPrinted();

                    alert('Print job queued.');
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            alert(useOverPrintMode ? 'No preprinted paper printer setup.' : 'No plain paper printer setup.');
        }
    }

    function printConsignmentLabel() {

        var printerName = authenticatedUser?.fmeUserInfo?.defaultDepotLabelPrinter?.printerName;

        if (printerName) {

            var headers = new Headers();
            headers.append('Content-Type', 'application/json');

            fetch(`api/consignments/${props.consignment.consignmentID}/print/ConsignmentLabel`, {
                credentials: 'include',
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    printerName: printerName
                })})
                .then(response => {
                    if (props.onPrinted)
                        props.onPrinted();

                    alert('Print job queued.');
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            alert('No label printer setup.');
        }
    }

    var canViewPrice = authenticatedUser?.fmeUserInfo?.permissions?.find(p => p.permission === 'FreightTracker__CanViewPrice')?.allowed === true;

    return (
        <React.Fragment>
            <Form className={styles.consignmentDetails} onSubmit={null}>
                <fieldset disabled>
                    <FormGroup row>
                        <Label sm={2} xs={3}>CN# {props.consignment.isProblem && <span className={styles.problem}><ProblemIcon /></span> }</Label>
                        <Col sm={10} xs={9}><Input type="text" value={props.consignment.connoteNumber} readOnly /></Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} xs={3}>CN Date</Label>
                        <Col sm={10} xs={9}><Input type="text" value={moment(props.consignment.connoteDate).format('YYYY-MM-DD')} readOnly /></Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2} xs={3}>Status</Label>
                        <Col sm={10} xs={9}><Input type="text" value={props.consignment.status} readOnly /></Col>
                    </FormGroup>
                    {
                        canViewPrice &&
                        <FormGroup row>
                            <Label sm={2} xs={4}>Total Charge</Label>
                            <Col sm={10} xs={8}><Input type="text" value={(canViewPrice && `$${props.consignment.totalPrice?.toFixed(2)}`) || ''} readOnly /></Col>
                        </FormGroup>
                    }
                </fieldset>
                <fieldset disabled>
                    <FormGroup>
                        <Label>From</Label>
                        <Input type="text" value={props.consignment.sender} readOnly />
                        <Input type="text" value={props.consignment.fromAddress1} readOnly />
                        <Input type="text" value={props.consignment.fromAddress2} readOnly />
                        <Input type="text" value={props.consignment.origin} readOnly />
                    </FormGroup>
                </fieldset>
                <fieldset disabled>
                    <FormGroup>
                        <Label>To</Label>
                        <Input type="text" value={props.consignment.receiver} readOnly />
                        <Input type="text" value={props.consignment.toAddress1} readOnly />
                        <Input type="text" value={props.consignment.toAddress2} readOnly />
                        <Input type="text" value={props.consignment.destination} readOnly />
                    </FormGroup>
                </fieldset>
            </Form>
            <div className={styles.buttonGroup}>
                <div>
                    <Button className={styles.btn} color="primary" onClick={navigateToGoodsDetails}><GoodsIcon /> Goods</Button>
                    <Button className={styles.btn} color="primary" onClick={navigateToTrackingDetails}><TrackIcon /> Tracking</Button>
                </div>
                <div>
                    <Button className={styles.btn} color="primary" onClick={e => printConsignmentReport(true)}><PrinterIcon /> Overprint</Button>
                    <Button className={styles.btn} color="primary" onClick={e => printConsignmentReport()}><PrinterIcon /> Plain Paper</Button>
                    <Button className={styles.btn} color="primary" onClick={e => printConsignmentLabel()}><PrinterIcon /> Labels</Button>
                </div>
                <div>
                    <Button className={styles.btn} color="primary" onClick={navigateToConsignmentDocuments}><DocumentsIcon /> Documents</Button>
                    <Button className={styles.btn} color="primary" onClick={navigateToConsignmentPods}><PodIcon /> PODs</Button>
                </div>
                <div>
                    <Button className={styles.btn} color="primary" onClick={handleProblem}><ProblemIcon /> {props.consignment.isProblem ? "Clear Problem" : "Mark Problem"}</Button>
                    <Button className={styles.btn} color="primary" onClick={navigateToChargingNotes}><NotesIcon /> Charging Notes</Button>
                </div>
            </div>
        </React.Fragment>
    );
}

function Consignment(props) {

    let { consignmentId } = useParams();

    const [consignment, setConsignment] = useState(null);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (!consignment) {
            setBusy(true);
            fetch(`api/consignments/${consignmentId}`,
                {
                    credentials: 'include'
                })
                .then(handleResponse)
                .then(data => {
                    setConsignment(data);
                    setBusy(false);
                })
                .catch(error => {
                    console.log(error);
                });
        }

    }, [consignment, consignmentId]);

    function refresh() {
        return fetch(`api/consignments/${consignmentId}`,
            {
                credentials: 'include'
            })
            .then(handleResponse)
            .then(data => {
                setConsignment(data);
            });
    }

    return busy ?
        <BusyIndicator isBusy={busy} /> : (
            consignment &&
            <ConsignmentDetails consignment={consignment} onPrinted={() => refresh()}/>
        );

}

export { Consignment };